import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper, Grid, Card, CardContent, Chip, Alert } from "@mui/material";
import {
  DescriptionOutlined,
  VpnKey,
  Build,
  AccountTree,
  Dashboard,
  Warning,
} from "@mui/icons-material";
import { useTenant } from "../hooks/useTenant";

export default function Home() {
  const navigate = useNavigate();
  const { currentTenant, isTenantSelected } = useTenant();

  const features = [
    {
      title: "Segredos",
      description: "Gerencie secrets e configurações sensíveis dos seus processos",
      icon: <VpnKey sx={{ fontSize: 40, color: "#FF006F" }} />,
      path: "/secrets"
    },
    {
      title: "Formulários",
      description: "Crie e gerencie formulários de tarefas para seus processos",
      icon: <DescriptionOutlined sx={{ fontSize: 40, color: "#FF006F" }} />,
      path: "/forms"
    },
    {
      title: "Modelador",
      description: "Crie e configure modelos de processo de forma visual",
      icon: <Build sx={{ fontSize: 40, color: "#FF006F" }} />,
      path: "/modeler"
    },
    {
      title: "Processos",
      description: "Monitore e gerencie a execução dos seus processos",
      icon: <AccountTree sx={{ fontSize: 40, color: "#FF006F" }} />,
      path: "/process-instances"
    },
    {
      title: "Dashboards",
      description: "Visualize métricas e insights dos seus processos",
      icon: <Dashboard sx={{ fontSize: 40, color: "#FF006F" }} />,
      path: "/dashboards"
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 3,
        marginLeft: "100px",
      }}
    >
      {/* Tenant Selection Alert */}
      {!isTenantSelected && (
        <Alert severity="warning" icon={<Warning />} sx={{ mb: 3 }}>
          Selecione um tenant para começar a usar a aplicação
        </Alert>
      )}

      {/* Tenant Info */}
      {isTenantSelected && currentTenant && (
        <Paper
          elevation={0}
          sx={{
            padding: 2,
            backgroundColor: "white",
            borderRadius: 2,
            mb: 3,
            border: `2px solid ${currentTenant.color}`,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Chip
              label={currentTenant.name}
              sx={{
                backgroundColor: currentTenant.color,
                color: 'white',
                fontWeight: 600,
              }}
            />
            <Typography variant="body1" color="text.secondary">
              {currentTenant.description}
            </Typography>
          </Box>
        </Paper>
      )}
      <Paper
        elevation={0}
        sx={{
          padding: 4,
          textAlign: "center",
          backgroundColor: "white",
          borderRadius: 2,
          mb: 4,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#333",
            mb: 2,
          }}
        >
          Orchestrator Console
          <span style={{ color: "#FF006F" }}>.</span>
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: "#666",
            mb: 3,
            fontWeight: 300,
          }}
        >
          Plataforma de Orquestração de Processos
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#888",
            maxWidth: 600,
            margin: "0 auto",
            lineHeight: 1.6,
          }}
        >
          Centralize e gerencie todos os aspectos dos seus processos de negócio
          com a plataforma de orquestração. Crie formulários, configure processos, gerencie segredos,
          monitore execuções e gerencie tarefas em uma interface unificada.
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                transition: "transform 0.2s, box-shadow 0.2s",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                },
              }}
              onClick={() => navigate(feature.path)}
            >
              <CardContent
                sx={{
                  textAlign: "center",
                  padding: 3,
                }}
              >
                <Box sx={{ mb: 2 }}>
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: 600,
                    color: "#333",
                    mb: 1,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#666",
                    lineHeight: 1.5,
                  }}
                >
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
